import type { ChangeEvent, FC } from "react";

import classNames from "classnames";

import { RadioButton } from "@jti/core-components";
import type { ICurrencyEnum } from "@jti/magento";
import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";
import { FormattedPrice, Txt, useTranslations } from "@jti/ui";

interface CheckOutLoyaltyPointsDiscountsListProps {
  currency: ICurrencyEnum;
  vouchers: GetEligibleCampaignsResponseType[];
  loyaltyCampaignId: string;
  isLoyaltyError: boolean;
  handleCampaignChange: (arg0: ChangeEvent<HTMLInputElement>) => void;
}

export const CheckOutLoyaltyPointsDiscountsList: FC<CheckOutLoyaltyPointsDiscountsListProps> = ({
  currency,
  vouchers,
  loyaltyCampaignId,
  isLoyaltyError,
  handleCampaignChange,
}) => {
  const { __ } = useTranslations();

  return (
    <div>
      {vouchers.map((item, index) => {
        const isDisabled = !item.is_eligible;
        const isChecked = loyaltyCampaignId === item.campaign_id;
        const classes = classNames({
          "checkout-loyalty-points__discounts--radio": true,
          checked: isChecked,
          error: isLoyaltyError && !isDisabled,
          disabled: isDisabled,
        });

        return (
          <div className={classes} key={item.campaign_id} data-testid={`redeemLabel_${index}`}>
            <RadioButton
              value={item.campaign_id}
              name={item.campaign_id}
              checked={isChecked}
              disabled={isDisabled}
              onChange={handleCampaignChange}
              data-testid={"redeemInput_" + index}
              label={
                <span className="checkout-loyalty-points__discounts--labelContent">
                  <span className="checkout-loyalty-points__discounts--pointsPrice">
                    <Txt variant="hl-10" dataTestId={"redeemPrice_" + index}>
                      <FormattedPrice currency={currency} value={item.price} />
                    </Txt>
                  </span>
                  <span className="checkout-loyalty-points__discounts--pointsValue">
                    <Txt variant="hl-9">{__("loyalty.checkout.pointsCost", [item.points])}</Txt>
                  </span>
                </span>
              }
            />
          </div>
        );
      })}
    </div>
  );
};
